import React, { useContext, useMemo } from 'react';
import LoadingPage from '../../components/LoadingPage';
import PodContextProvider from './PodContextProvider';
import PodContext from './PodContext';

const withPodContextProvider = (Component) => React.memo((props) => (
  <PodContextProvider>
    <Component {...props} />
  </PodContextProvider>
));

const withPodContextReady = (Component) => React.memo((props) => {
  const { isReady, ...rest } = useContext(PodContext);

  const content = useMemo(() => (
    isReady ? <Component {...props} podContext={rest} /> : <LoadingPage />
  ), [isReady, props, rest]);
  return content;
});

export { withPodContextProvider, withPodContextReady };
